import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/DetailSurat.css';
import {
  FiBook,
  FiPlayCircle,
  FiPauseCircle,
  FiSearch,
  FiSave,
} from 'react-icons/fi';
import HeaderSurat from '../components/HeaderSurat';
import TafsirAyat from './TafsirAyat';
import { Howl } from 'howler';
import Navbar from '../components/Navbar';
import RecorderComponent from '../components/Recorder';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { db } from '../firebase';
import { doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import { UserAuth } from '../context/AuthContext';
import AudioFull from '../components/AudioFull';
import FontSize from '../components/FontSize';
import { NewMainContext } from '../context/MainContext';
import { ModalFromSaved, ModalDetail } from '../components/Modal';
import { ButtonScrollTop } from '../components/Button';
import { SkipButton } from '../components/SkipButton';

const DetailSurat = () => {
  const [ayat, setAyat] = useState([]);
  const [surah, setSurah] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [playingAudios, setPlayingAudios] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [showRecord, setShowRecord] = useState(false);
  const [showAudio, setShowAudio] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const [textSize, setTextSize] = useState(30);
  const [isRecording, setIsRecording] = useState(false);
  const { user } = UserAuth();
  let { id, ayatSaved } = useParams();
  let { setOpenModalFromSaved, openModalFromSaved } = NewMainContext();

  const fetchAyat = async () => {
    try {
      const response = await axios.get(`https://equran.id/api/v2/surat/${id}`);
      setAyat(response.data.data.ayat);
      setSurah(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('error', error);
    }
  };

  const togglePopup = (ayatId) => {
    setShowPopup(ayatId);
  };

  const togglePopup2 = (ayatId) => {
    setShowPopup2(ayatId);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };

  const playAudio = (audio, ayatId) => {
    const index = playingAudios.findIndex((item) => item.ayatId === ayatId);

    if (index !== -1 && playingAudios[index].audio === audio) {
      const sound = playingAudios[index].sound;
      sound.stop();
      setPlayingAudios((prevAudios) =>
        prevAudios.filter((item) => item.ayatId !== ayatId)
      );
    } else {
      const updatedAudios = playingAudios.map((prevAudio) =>
        prevAudio.ayatId === ayatId
          ? { ...prevAudio, playing: true }
          : { ...prevAudio, playing: false }
      );

      updatedAudios.forEach((item) => {
        const sound = item.sound;
        sound.stop();
      });

      const sound = new Howl({
        src: [audio],
        html5: true,
        onplay: () => {
          const newPlayingAudio = { ayatId, audio, sound, playing: true };
          setPlayingAudios((prevAudios) => [...updatedAudios, newPlayingAudio]);
        },
        onend: () => {
          setPlayingAudios((prevAudios) =>
            prevAudios.filter((item) => item.ayatId !== ayatId)
          );
        },
      });

      sound.play();
    }
  };

  const saveLastRead = async (nomorAyat) => {
    try {
      if (user?.uid) {
        const userRef = doc(db, user.uid, 'Terakhir Baca');

        const lastReadData = {
          nama_surah: surah.nama,
          nomor_ayat: nomorAyat,
          nomor_surat: surah.nomor,
          nama_latin: surah.namaLatin,
          tanggal: getCurrentDate(),
          waktu: getCurrentTime(),
        };
        await setDoc(userRef, lastReadData);
      } else {
        console.error(
          'Pengguna belum masuk atau sesi autentikasi pengguna tidak aktif. Tidak dapat menyimpan bookmark ke Firestore.'
        );
      }
    } catch (error) {
      console.error('Error saat menyimpan bookmark ke Firestore:', error);
    }
    setShowPopup2(false);
  };

  const saveHistory = async (nomorAyat) => {
    try {
      if (user?.uid) {
        const userRef = doc(db, user.uid, 'Riwayat Hafalan');
        const userDoc = await getDoc(userRef);

        if (!userDoc.exists()) {
          const historyData = {
            bookmarks: [
              {
                nomor_ayat: nomorAyat,
                nama_surah: surah.nama,
                nama_latin: surah.namaLatin,
                nomor_surat: surah.nomor,
                tanggal: getCurrentDate(),
                waktu: getCurrentTime(),
                id: Math.random(),
              },
            ],
          };

          await setDoc(userRef, historyData);
        } else {
          const historyData = userDoc.data();
          const newBookmark = {
            nomor_ayat: nomorAyat,
            nama_surah: surah.nama,
            nama_latin: surah.namaLatin,
            nomor_surat: surah.nomor,
            tanggal: getCurrentDate(),
            waktu: getCurrentTime(),
            id: Math.random(),
          };

          const updatedBookmarks = [...historyData.bookmarks, newBookmark];
          await updateDoc(userRef, { bookmarks: updatedBookmarks });
        }
      } else {
        console.error(
          'Pengguna belum masuk atau sesi autentikasi pengguna tidak aktif. Tidak dapat menyimpan bookmark ke db.'
        );
      }
    } catch (error) {
      console.error('Error saat menyimpan bookmark ke db:', error);
    }
    setShowPopup2(false);
  };

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = now.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    if (hours < 10) {
      hours = '0' + hours;
    }
    let minutes = now.getMinutes();
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    return `${hours}:${minutes}`;
  };

  const handleMenuClick = (item) => {
    if (item === 'Cari') {
      setShowSearch(true);
      setShowRecord(false);
      setShowAudio(false);
      setShowSetting(false);
    } else if (item === 'Murojaah') {
      setShowRecord(true);
      setShowSearch(false);
      setSearchText('');
      setShowAudio(false);
      setShowSetting(false);
    } else if (item === 'Audio') {
      setShowAudio(true);
      setShowSearch(false);
      setShowRecord(false);
      setSearchText('');
      setShowSetting(false);
    } else if (item === 'Setting') {
      setShowSetting(true);
      setShowSearch(false);
      setShowRecord(false);
      setSearchText('');
      setShowAudio(false);
    }
  };

  const searchAyat = useCallback(() => {
    const results = ayat.filter((surat) => {
      const arabicText = surat.teksArab.toLowerCase();
      const latinText = surat.teksLatin.toLowerCase();
      const indoText = surat.teksIndonesia.toLowerCase();
      const nomorAyat = surat.nomorAyat.toString();
      const searchTextLower = searchText.toLowerCase();
      return (
        arabicText.includes(searchTextLower) ||
        latinText.includes(searchTextLower) ||
        indoText.includes(searchTextLower) ||
        nomorAyat.includes(searchTextLower)
      );
    });
    setSearchResults(results);
  }, [searchText, ayat]);

  useEffect(() => {
    fetchAyat();
  }, [id]);

  useEffect(() => {
    if (ayatSaved >= 1) {
      setOpenModalFromSaved(true);
    }
  }, []);

  useEffect(() => {
    searchAyat();
  }, [searchText, ayat, searchAyat]);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      if (newWidth < 768) {
        setTextSize(20);
      } else {
        setTextSize(30);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <>
        <Navbar />
        <Loader />;
        <Footer />
      </>
    );
  }

  return (
    <div className='root'>
      {openModalFromSaved === true ? (
        <ModalFromSaved linkList={ayatSaved} />
      ) : (
        ''
      )}
      <div className='root-detail-surat'>
        <div className='detail-surat'>
          <SkipButton idName='#detail-surat-content' />
          <Navbar />
          <HeaderSurat handleMenuClick={handleMenuClick} surah={surah} />
          <div className='action-bar'>
            {showSearch && (
              <div className='search-input'>
                <input
                  type='text'
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder='Cari sesuatu...'
                  className='search-input2'
                  id='search-input2'
                />
                <FiSearch className='search-button' />{' '}
              </div>
            )}
            {showRecord && (
              <RecorderComponent
                isRecording={isRecording}
                setIsRecording={setIsRecording}
              />
            )}
            {showAudio && <AudioFull surah={surah} />}
            {showSetting && (
              <FontSize setTextSize={setTextSize} textSize={textSize} />
            )}
          </div>
          {!isRecording && searchResults.length > 0 ? (
            <div className='search-results'>
              {searchResults.map((surat) => (
                <div
                  className='detail-ayat'
                  key={surat.nomorAyat}
                  id={surat.nomorAyat}
                >
                  <div className='header-ayat' id='detail-surat-content'>
                    <p className='nomor'>{surat.nomorAyat}</p>
                    <p className='arab' style={{ fontSize: `${textSize}px` }}>
                      {surat.teksArab}
                    </p>
                  </div>
                  <p className='latin'>{surat.teksLatin}</p>
                  <p className='indo'>"{surat.teksIndonesia}"</p>
                  <hr className='break-row' />
                  <div className='button-detail'>
                    <button
                      onClick={() => togglePopup(surat.nomorAyat)}
                      className='link'
                      aria-label='tafsir ayat'
                    >
                      <FiBook className='button-icon' />
                    </button>
                    <button
                      onClick={() =>
                        playAudio(surat.audio['05'], surat.nomorAyat)
                      }
                      aria-label='play ayat'
                    >
                      {playingAudios.find(
                        (item) => item.ayatId === surat.nomorAyat
                      ) &&
                      playingAudios.find(
                        (item) => item.ayatId === surat.nomorAyat
                      ).playing ? (
                        <FiPauseCircle className='button-icon' />
                      ) : (
                        <FiPlayCircle className='button-icon' />
                      )}
                    </button>{' '}
                    <button
                      onClick={() => togglePopup2(surat.nomorAyat)}
                      aria-label='Save ayat'
                    >
                      <FiSave className='button-icon' />
                    </button>
                  </div>
                  {showPopup2 === surat.nomorAyat && (
                    <ModalDetail
                      saveHistory={() => saveHistory(surat.nomorAyat)}
                      saveLastRead={() => saveLastRead(surat.nomorAyat)}
                      closePopup2={closePopup2}
                      show={showPopup2 !== null}
                    />
                  )}
                  {showPopup === surat.nomorAyat && (
                    <TafsirAyat
                      handleClose={() => togglePopup(null)}
                      show={showPopup !== null}
                      nomorSurat={surah.nomor}
                      id={surat.nomorAyat}
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            ''
          )}
          {isRecording && <p className='merekam'>Sedang Merekam ....</p>}
          <ButtonScrollTop />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DetailSurat;
